<template>
    <div>
        <div v-if="notification.type == 1" class="alert alert-success">
            <b>{{notification.message}}</b>
        </div>
        <div v-if="notification.type == 2" class="alert alert-danger">
            <b>{{notification.message}}</b>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex' 
export default {
    name:'notification',
    computed:{
        ...mapState({ 
            notification:(state)=>state.notification
        }),
    },
}
</script>
